import React from 'react';
import { Check, X, Zap } from 'lucide-react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionTransform } from './types';

export const SolutionCommercialTransform: React.FC<{
  transform: SolutionTransform;
}> = ({ transform }) => (
  <SiteSection id="transformation" className="cl-transform">
    <SiteSectionHeader
      eyebrow={transform.eyebrow}
      title={transform.title}
      subtitle={transform.subtitle}
      align="center"
    />

    <div className="cl-transform__showcase">
      <article className="cl-transform__panel cl-transform__panel--before">
        <span className="cl-transform__panel-tag">Before</span>
        <h3 className="cl-transform__panel-title">{transform.before.title}</h3>
        <ul className="cl-transform__list">
          {transform.before.items.map((item) => (
            <li key={item}>
              <span className="cl-transform__icon cl-transform__icon--before" aria-hidden>
                <X size={16} strokeWidth={2.5} />
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </article>

      <div className="cl-transform__spine" aria-hidden>
        <div className="cl-transform__spine-line" />
        <div className="cl-transform__spine-node">
          <Zap size={20} strokeWidth={2.25} />
          <span>{transform.arrowLabel}</span>
        </div>
        <div className="cl-transform__spine-line cl-transform__spine-line--bottom" />
      </div>

      <article className="cl-transform__panel cl-transform__panel--after">
        <span className="cl-transform__panel-tag cl-transform__panel-tag--after">After</span>
        <h3 className="cl-transform__panel-title">{transform.after.title}</h3>
        <ul className="cl-transform__list">
          {transform.after.items.map((item) => (
            <li key={item}>
              <span className="cl-transform__icon cl-transform__icon--after" aria-hidden>
                <Check size={16} strokeWidth={2.5} />
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </article>
    </div>
  </SiteSection>
);
